export const courseDetails = [
    // course data hierarchy (chronological order)
    {
        title: "SCDF-Dell Lifesavers’ Innovation Challenge 2025",
        img: [
            "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/documents/SCDFHackathon/1.jpg",
            "https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/documents/SCDFHackathon/2.jpg"
        ]
    },
    {
        title: "Global Startup Hackathon Challenge 2021",
        img: ["https://reactportfolio-bucket.s3.ap-southeast-1.amazonaws.com/documents/GEIP.png"]
    }
]
